//  get homeowners list
export const REQUEST_HOMEOWNERS_LIST = "REQUEST_HOMEOWNERS_LIST";
export const RECEIVE_HOMEOWNERS_LIST ="RECEIVE_HOMEOWNERS_LIST";